import {
  SET_SG_GAME_NAMES,
  SET_SG_GAME_IMAGES,
  SET_SG_GAME_POLA,
  SET_GAME_ISLOADING,
  SET_GAME_ISERROR
} from '../actionTypes';

const initialState = {
  sgNames: [],
  sgImages: [],
  sgPolas: [],
  nameAndImagesIsLoading: true,
  isError: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SG_GAME_NAMES:
      return { ...state, sgNames: action.payload }
    case SET_SG_GAME_IMAGES:
      return { ...state, sgImages: action.payload };
    case SET_SG_GAME_POLA:
      return { ...state, sgPolas: action.payload };
    case SET_GAME_ISLOADING:
      return { ...state, nameAndImagesIsLoading: action.payload };
    case SET_GAME_ISERROR:
      return { ...state, isError: action.payload };
    default:
      return state;
  };
};

export default reducer;